module.exports = __webpack_public_path__ + "static/bed-frame-2-abd007619cfd9b7571e654a0d622f532.webp";